/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.StatsList = function( data) {
    var prop;
	var doc = document;
    var span = null;
	var item = null;
	var toggle = 1;
    var list = document.createElement( "table");
	list.setAttribute( "class", "statsList");
    
    for( prop in data) {
		if( data.hasOwnProperty( prop)) {
			item = doc.createElement( "tr");
			item.className = ( toggle ===1) ? "even" : "odd";
			span = doc.createElement( "td");
			span.className = "statLabel";
			span.textContent = prop;
			item.appendChild( span);
			span = doc.createElement( "td");
			span.className = "statValue";
			span.textContent = data[prop];
			item.appendChild( span);
			list.appendChild( item);
			toggle *= -1;
		}
	}
	
    return list;
};